import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Breadcrumb } from 'react-bootstrap';

const Breadcrumbs = () => {
    const location = useLocation();

    // Map of paths to their display names
    const pathNames = {
        'dashboard': 'Dashboard',
        'staff-checkin': 'Staff Check-in',
        'staff-checkout': 'Staff Check-out',
        'ict': 'ICT',
        'checkout-list': 'Checkout List',
        'ict-asset': 'Asset Management',
        'role-management': 'Role Management',
        'security': 'Security',
        'hr': 'HR',
        'staff-list': 'Staff List',
        'users': 'Users',
        'user-detail': 'User Details'
    };

    // Function to generate breadcrumb items
    const getBreadcrumbs = () => {
        const paths = location.pathname.split('/').filter(path => path);
        let breadcrumbs = [];
        let currentPath = '';

        // Always include Home as the first breadcrumb
        breadcrumbs.push({
            path: '/dashboard',
            name: 'Dashboard',
            isActive: paths.length === 0
        });

        // Build the rest of the breadcrumbs
        paths.forEach((path, index) => {
            currentPath += `/${path}`;
            if (path !== 'dashboard') { // Skip dashboard since we already added it
                breadcrumbs.push({
                    path: currentPath,
                    name: pathNames[path] || path,
                    isActive: index === paths.length - 1
                });
            }
        });

        return breadcrumbs;
    };

    const breadcrumbs = getBreadcrumbs();

    return (
        <div className="bg-light py-2 px-4 mb-4 border-bottom">
            <Breadcrumb className="mb-0">
                {breadcrumbs.map((breadcrumb, index) => (
                    <Breadcrumb.Item
                        key={breadcrumb.path}
                        active={breadcrumb.isActive}
                        linkAs={Link}
                        linkProps={{ to: breadcrumb.path }}
                        className="d-flex align-items-center"
                    >
                        {index > 0 && (
                            <ChevronRight size={16} className="mx-2 text-muted" />
                        )}
                        {breadcrumb.name}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        </div>
    );
};

export default Breadcrumbs;